export const EMAIL_TYPE_OPTIONS = [
  { value: 'office',    label: 'Office' },
  { value: 'personal', label: 'Personal' },
  { value: 'other',    label: 'Other' },
];
